export default __webpack_public_path__ + "static/media/2223 utensils side.1615e0ab.png";